import { Box, Grid } from "@mui/material";
import React, { useState } from "react";
import Textfield from "../../shared/textfield";

export default function ImmunizationHistory(props) {

  const [disabledField, setDisabledField] = useState(true);

  // const handleEdit = () => {
  //   setDisabledField(!disabledField);
  //   if (!disabledField) {
  //     // To save changes here
  //   }
  // };

  // const handleCancelEdit = () => {
  //   setDisabledField(true);
  // };

  const profile = props.profile;

  return (
    <Box ml={2} mr={2} mb={2}>

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Textfield
            title='Immunization History'
            value={profile.maternalBirthHistory?.immunizationsHistory}
            disabled={disabledField}
            multiline
            rows={2}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
